import { secondAxios } from "../../../../../api/axios";

const BASE = "/resource";

export const RESOURCE_UNIT_OPTIONS = ["hr", "$"];

export const normalizeResourceUnit = (unit) =>
  String(unit ?? "hr").trim() === "$" ? "$" : "hr";

/** @typedef {{ id: string, name: string, rate: number, unit: string, createdAt?: string, updatedAt?: string }} ResourceRow */

/** @param {object} raw */
export function mapResourceDto(raw) {
  if (!raw) return null;
  const unit = normalizeResourceUnit(raw.unit);
  return {
    id: raw.id,
    name: String(raw.name ?? "").trim(),
    rate: Number(raw.rate) || 0,
    unit,
    createdAt: raw.createdAt,
    updatedAt: raw.updatedAt,
  };
}

/** @returns {Promise<ResourceRow[]>} */
export async function fetchResources() {
  const { data } = await secondAxios.get(BASE);
  const list = Array.isArray(data) ? data : [];
  return list.map(mapResourceDto).filter(Boolean);
}

/** @returns {Promise<ResourceRow>} */
export async function fetchResource(id) {
  const { data } = await secondAxios.get(`${BASE}/${id}`);
  return mapResourceDto(data);
}

/** @param {{ name: string, rate: number, unit: string }} payload */
export async function createResource(payload) {
  const { data } = await secondAxios.post(BASE, {
    name: String(payload.name ?? "").trim(),
    rate: Number(payload.rate) || 0,
    unit: normalizeResourceUnit(payload.unit),
  });
  return mapResourceDto(data);
}

/** @param {string} id @param {{ name?: string, rate?: number, unit?: string }} payload */
export async function updateResource(id, payload) {
  const body = {};
  if (payload.name !== undefined) body.name = String(payload.name).trim();
  if (payload.rate !== undefined) body.rate = Number(payload.rate) || 0;
  if (payload.unit !== undefined) body.unit = normalizeResourceUnit(payload.unit);
  const { data } = await secondAxios.patch(`${BASE}/${id}`, body);
  return mapResourceDto(data);
}

/** @param {string} id */
export async function deleteResource(id) {
  await secondAxios.delete(`${BASE}/${id}`);
}
